var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{class:`${_vm.col ? 'flex-column' : ''}`},[_c('b-col',[_c('GoogleLogin',{attrs:{"login":_vm.isLogin,"purchase-mode":_vm.purchaseMode},on:{"click":_vm.googleLogin}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }